export default function VT01({ module }) {
    const items = module.items || [];

    return (
        <section className="w-full p-4" aria-labelledby="videotheque">
            <div className="max-w-6xl mx-auto p-4 bg-white dark:bg-gray-900 rounded-lg shadow-lg">
                {/* Titre */}
                <h2 id="videotheque" className="text-3xl font-bold mb-6 text-gray-900 dark:text-white">
                    {module.title || "Ma vidéothèque"}
                </h2>
                {/* Grille des vidéos */}
                {items.length > 0 ? (
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                        {items.map((item) => (
                            <div key={item.id} className="relative rounded-lg overflow-hidden shadow-md">
                                {/* Iframe YouTube */}
                                {item.link && (
                                    <iframe
                                        className="w-full h-64 rounded-lg"
                                        src={item.link}
                                        title={item.title || "Vidéo"}
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    ></iframe>
                                )}

                                {/* Hover avec icône */}
                                <div className="absolute inset-0 flex items-center justify-center opacity-0 hover:opacity-100 hover:bg-white hover:bg-opacity-50 transition duration-300">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-12 w-12 text-gray-800 dark:text-white"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M15 10l4.553-4.553a1 1 0 00-1.414-1.414L13.586 8.586a2 2 0 01-2.828 0L5.861 3.861A1 1 0 004.447 5.275L9 10m6 4l4.553 4.553a1 1 0 01-1.414 1.414L13.586 15.414a2 2 0 00-2.828 0L5.861 20.139a1 1 0 01-1.414-1.414L9 14"
                                        />
                                    </svg>
                                </div>

                                {/* Titre sous la vidéo */}
                                {item.title && (
                                    <p className="mt-2 text-sm font-medium text-gray-800 dark:text-gray-200 px-1">
                                        {item.title}
                                    </p>
                                )}
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className="text-gray-600 dark:text-gray-300 text-center">
                        Aucune vidéo disponible pour le moment.
                    </p>
                )}
            </div>
        </section>
    );
}
